import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "budget-wizard" }
const _hoisted_2 = { class: "budget-wizard__head" }
const _hoisted_3 = { class: "budget-wizard__tools" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "budget-wizard__meta" }
const _hoisted_6 = { class: "budget-wizard__title-row" }
const _hoisted_7 = { class: "budget-wizard__title" }
const _hoisted_8 = { class: "budget-wizard__count" }
const _hoisted_9 = {
  class: "budget-wizard__nav",
  "aria-label": "단계"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "budget-wizard__nav-num" }
const _hoisted_12 = { class: "budget-wizard__nav-label" }
const _hoisted_13 = {
  key: 0,
  class: "budget-wizard__nav-sep"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "budget-wizard__warn"
}
const _hoisted_16 = { class: "wizard-grid__head" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 4,
  class: "hc"
}
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 1,
  class: "wizard-grid__grade"
}
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["value"]
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = ["value"]
const _hoisted_28 = ["value", "onInput"]
const _hoisted_29 = ["value", "onInput"]
const _hoisted_30 = ["value", "onInput"]
const _hoisted_31 = { class: "wizard-grid__figures" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 6 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "wizard-grid wizard-grid--staff" }
const _hoisted_39 = ["onUpdate:modelValue", "onChange"]
const _hoisted_40 = ["value"]
const _hoisted_41 = ["value"]
const _hoisted_42 = ["value", "onInput"]
const _hoisted_43 = ["value", "onInput"]
const _hoisted_44 = {
  key: 0,
  class: "wizard-grid__check",
  title: "대표"
}
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "wizard-grid__figures" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "budget-wizard__add-row" }
const _hoisted_51 = {
  key: 0,
  class: "wizard-mini"
}
const _hoisted_52 = { class: "wizard-mini__row" }
const _hoisted_53 = { class: "budget-wizard__field" }
const _hoisted_54 = ["value"]
const _hoisted_55 = { class: "budget-wizard__field budget-wizard__field--wide" }
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "budget-wizard__field budget-wizard__field--wide" }
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "wizard-grid__figures" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 2 }
const _hoisted_62 = { class: "wizard-find" }
const _hoisted_63 = { class: "wizard-gwan__name" }
const _hoisted_64 = {
  key: 0,
  class: "wizard-hang__name"
}
const _hoisted_65 = {
  key: 0,
  class: "wizard-money__title"
}
const _hoisted_66 = { class: "wizard-money__name" }
const _hoisted_67 = { class: "wizard-money__tag" }
const _hoisted_68 = ["value", "onInput"]
const _hoisted_69 = { class: "wizard-money__tag wizard-money__tag--b" }
const _hoisted_70 = ["value", "placeholder", "onInput"]
const _hoisted_71 = {
  key: 1,
  class: "wizard-money__slot"
}
const _hoisted_72 = {
  key: 0,
  class: "budget-wizard__quiet"
}
const _hoisted_73 = { key: 3 }
const _hoisted_74 = { class: "budget-wizard__totals" }
const _hoisted_75 = { class: "wizard-total wizard-total--in" }
const _hoisted_76 = { class: "wizard-total wizard-total--out" }
const _hoisted_77 = { class: "wizard-banner__main" }
const _hoisted_78 = { class: "wizard-banner__value" }
const _hoisted_79 = { class: "wizard-banner__sub" }
const _hoisted_80 = {
  key: 1,
  class: "budget-wizard__quiet"
}
const _hoisted_81 = {
  key: 2,
  class: "wizard-review"
}
const _hoisted_82 = { class: "wizard-review__col" }
const _hoisted_83 = { class: "wizard-review__col" }
const _hoisted_84 = { class: "budget-wizard__foot" }
const _hoisted_85 = {
  key: 0,
  class: "wizard-foot-total"
}
const _hoisted_86 = { class: "wizard-foot-total__in" }
const _hoisted_87 = { class: "wizard-foot-total__out" }
const _hoisted_88 = {
  key: 0,
  class: "wizard-foot-total__labor"
}
const _hoisted_89 = { class: "budget-wizard__foot-bar" }
const _hoisted_90 = { class: "wizard-foot-note" }
const _hoisted_91 = {
  key: 0,
  class: "wizard-foot-note__line"
}
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { class: "budget-wizard__foot-main" }
const _hoisted_94 = ["disabled"]
const _hoisted_95 = {
  class: "wizard-ask__card",
  role: "dialog",
  "aria-labelledby": "wizard-ask-title"
}
const _hoisted_96 = {
  id: "wizard-ask-title",
  class: "wizard-ask__title"
}
const _hoisted_97 = { class: "wizard-ask__lead" }
const _hoisted_98 = {
  key: 0,
  class: "wizard-ask__auto"
}
const _hoisted_99 = { class: "wizard-ask__auto-title" }
const _hoisted_100 = { class: "wizard-ask__group-row" }
const _hoisted_101 = ["checked", "onChange"]
const _hoisted_102 = { class: "wizard-ask__auto-label" }
const _hoisted_103 = ["onClick"]
const _hoisted_104 = {
  key: 0,
  class: "wizard-ask__detail-list"
}
const _hoisted_105 = ["checked", "onChange"]
const _hoisted_106 = { class: "wizard-ask__auto-label" }
const _hoisted_107 = { class: "wizard-ask__actions" }

import { computed, onBeforeUnmount, reactive, ref, watch } from "vue";
import {
  budgetWizardFamily,
  buildWizardLines,
  clearWizardDraft,
  createGradeAnswers,
  createWizardAnswers,
  dayHourOptions,
  extraGrade,
  familyUsesBasicSplit,
  familyUsesTreatment,
  formatWon,
  formatWonInput,
  gradeLabelOptions,
  hydrateWizardAnswers,
  readWizardDraft,
  writeWizardDraft,
  insuranceGridTotal,
  laborStatus,
  lineAmount,
  MONEY_FIELDS,
  moneyGroups,
  type MoneySheetGwan,
  parseWon,
  preferredDayHours,
  previewPair,
  resolvedGradeRank,
  retirementGridTotal,
  salaryRoleOptions,
  listIncomeMirrors,
  wizardSteps,
  type MoneyField,
  type MoneyMode,
  type WizardAnswers,
  type WizardLine,
  type WizardSheetRow,
  type WizardSuga,
  type WizardTax,
} from "@/utils/budgetWizard";

interface AutoItem {
  key: string;
  label: string;
  amount: number;
  defaultOff?: boolean;
}

interface AutoGroup {
  id: string;
  title: string;
  items: AutoItem[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BudgetWizard',
  props: {
    modelValue: { type: Boolean },
    bizGubun: {},
    year: {},
    budgetLabel: {},
    sugaList: {},
    tax: {},
    hasExisting: { type: Boolean },
    sheetRows: {},
    draftKey: {}
  },
  emits: ["update:modelValue", "apply"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const family = computed(() => budgetWizardFamily(props.bizGubun));
const steps = computed(() => wizardSteps(family.value));
const incomeGroups = computed(() => moneyGroups("income", family.value));
const spendGroups = computed(() => moneyGroups("spend", family.value));
const stepIndex = ref(0);
const askKind = ref<"" | "apply" | "close" | "sheet" | "draft" | "reset">("");
const excludedAuto = ref<Record<string, boolean>>({});
const viewSource = ref<"sheet" | "draft">("sheet");
const storedDraftAt = ref("");
const baseline = ref("");
const blanked = ref(false);
const autosaveOn = ref(false);
const savedStep = ref(0);
let autosaveTimer: ReturnType<typeof setTimeout> | null = null;
const step = computed(() => steps.value[stepIndex.value] || steps.value[0]);
const hourOptions = computed(() => dayHourOptions(props.sugaList));
const usesBasic = computed(() => familyUsesBasicSplit(family.value));

const peopleGridClass = computed(() => {
  if (family.value === "day") return "wizard-grid--day";
  if (family.value === "facility") return "wizard-grid--people-split";
  if (family.value === "care" || family.value === "bath") return "wizard-grid--visit";
  return "wizard-grid--people";
});

function moneyInputCopy(mode: MoneyMode): { a: string; b: string } {
  if (mode === "times") return { a: "1회 금액", b: "횟수" };
  if (mode === "people") return { a: "1명 한 달", b: "인원" };
  if (mode === "span") return { a: "한 달 금액", b: "개월" };
  if (mode === "monthly") return { a: "한 달 금액", b: "" };
  return { a: "1년 금액", b: "" };
}

/** 수입·지출 입력줄의 연간 금액 미리보기 (buildWizardLines와 같은 규칙) */
function annualFieldAmount(field: MoneyField): number {
  const bag = moneyBag(field.id);
  const a = parseWon(bag.a);
  const b = parseWon(bag.b);
  if (a <= 0) return 0;
  if (field.mode === "annual") return a;
  if (field.mode === "monthly") return a * 12;
  if (field.mode === "span") return a * (b > 0 ? b : 12);
  if (field.mode === "times") return b > 0 ? a * b : 0;
  return b > 0 ? a * b * 12 : 0;
}

/** 처우개선비 연간 합계 — (보조 + 본인) × 인원 × 12 */
function treatmentAnnual(): number {
  const count = parseWon(answers.treatmentCount);
  const subsidy = parseWon(answers.treatmentSubsidy);
  const copay = parseWon(answers.treatmentCopay);
  if (count <= 0 || (subsidy <= 0 && copay <= 0)) return 0;
  return (subsidy + copay) * count * 12;
}

/** 표에 넣기에서 고를 수 있는 자동 계산. 사람별 금액은 사회보험·퇴직적립금으로 묶어서 보여 줌 */
const detailOpen = ref<Record<string, boolean>>({});

const autoGroups = computed<AutoGroup[]>(() => {
  const insurance: AutoItem[] = [];
  const retirement: AutoItem[] = [];
  answers.staff.forEach((person) => {
    const preview = staffPreview(person);
    if (!preview) return;
    const role = `${person.role}${person.isCeo ? "(대표자)" : ""}`;
    if (preview.ins > 0) insurance.push({ key: `${person.id}:ins`, label: role, amount: preview.ins });
    if (preview.ret > 0) retirement.push({ key: `${person.id}:ret`, label: role, amount: preview.ret });
  });
  const groups: AutoGroup[] = [];
  if (insurance.length) groups.push({ id: "ins", title: "인건비에서 계산한 사회보험", items: insurance });
  if (retirement.length) groups.push({ id: "ret", title: "인건비에서 계산한 퇴직적립금", items: retirement });
  listIncomeMirrors(family.value, answers).forEach((mirror) => {
    groups.push({
      id: mirror.key,
      title: mirror.label,
      items: [{ key: mirror.key, label: mirror.label, amount: mirror.amount, defaultOff: mirror.defaultOff }],
    });
  });
  return groups;
});

const autoItems = computed(() => autoGroups.value.flatMap((group) => group.items));

function isAutoOff(item: AutoItem): boolean {
  const choice = excludedAuto.value[item.key];
  if (choice === true) return true;
  if (choice === false) return false;
  return Boolean(item.defaultOff);
}

const autoKeptTotal = computed(() => autoItems.value.filter((item) => !isAutoOff(item)).reduce((sum, item) => sum + item.amount, 0));

const excludedAutoKeys = computed(() => autoItems.value.filter((item) => isAutoOff(item)).map((item) => item.key));

function toggleAuto(item: AutoItem) {
  excludedAuto.value = { ...excludedAuto.value, [item.key]: !isAutoOff(item) };
}

function groupKeptCount(group: AutoGroup): number {
  return group.items.filter((item) => !isAutoOff(item)).length;
}

function groupKept(group: AutoGroup): number {
  return group.items.filter((item) => !isAutoOff(item)).reduce((sum, item) => sum + item.amount, 0);
}

function groupTotal(group: AutoGroup): number {
  return group.items.reduce((sum, item) => sum + item.amount, 0);
}

function toggleGroup(group: AutoGroup) {
  const turnOff = groupKeptCount(group) === group.items.length;
  const next = { ...excludedAuto.value };
  group.items.forEach((item) => {
    next[item.key] = turnOff;
  });
  excludedAuto.value = next;
}

function toggleDetail(id: string) {
  detailOpen.value = { ...detailOpen.value, [id]: !detailOpen.value[id] };
}

function paintGroupBox(el: unknown, group: AutoGroup) {
  if (!(el instanceof HTMLInputElement)) return;
  const kept = groupKeptCount(group);
  el.indeterminate = kept > 0 && kept < group.items.length;
}

function goTo(index: number) {
  if (index < 0 || index >= steps.value.length) return;
  stepIndex.value = index;
}

const moneyQuery = ref("");

const visibleMoneyGroups = computed((): MoneySheetGwan[] => {
  const source = step.value.id === "income" ? incomeGroups.value : spendGroups.value;
  const query = moneyQuery.value.trim();
  return source
    .map((gwan) => ({
      gwan: gwan.gwan,
      hangs: gwan.hangs
        .map((hang) => ({
          hang: hang.hang,
          showHang: hang.showHang,
          groups: hang.groups
            .map((group) => ({
              title: group.title,
              fields: group.fields.filter((field) => !query || `${field.label} ${field.hint} ${group.title} ${hang.hang} ${gwan.gwan}`.includes(query)),
            }))
            .filter((group) => group.fields.length > 0),
        }))
        .filter((hang) => hang.groups.length > 0),
    }))
    .filter((gwan) => gwan.hangs.length > 0);
});

function focusNextField(event: KeyboardEvent) {
  const target = event.target;
  if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLSelectElement)) return;
  if (target instanceof HTMLInputElement && target.type === "checkbox") return;
  const root = event.currentTarget;
  if (!(root instanceof HTMLElement)) return;
  const fields = Array.from(root.querySelectorAll("input, select")).filter((node) => {
    if (!(node instanceof HTMLInputElement) && !(node instanceof HTMLSelectElement)) return false;
    if (node.disabled) return false;
    if (node instanceof HTMLInputElement && node.type === "checkbox") return false;
    return node.getClientRects().length > 0;
  });
  const next = fields[fields.indexOf(target) + 1];
  if (!(next instanceof HTMLElement)) return;
  event.preventDefault();
  next.focus();
}

const answers = reactive<WizardAnswers>(createWizardAnswers(props.bizGubun, props.sugaList));

function fillAnswers(next: WizardAnswers) {
  answers.dayHours = next.dayHours;
  answers.grades.splice(0, answers.grades.length, ...next.grades);
  answers.staff.splice(0, answers.staff.length, ...next.staff);
  answers.treatmentCount = next.treatmentCount;
  answers.treatmentSubsidy = next.treatmentSubsidy;
  answers.treatmentCopay = next.treatmentCopay;
  Object.keys(answers.money).forEach((key) => delete answers.money[key]);
  Object.assign(answers.money, next.money);
  MONEY_FIELDS.forEach((field) => {
    if (!answers.money[field.id]) answers.money[field.id] = { a: "", b: field.mode === "span" ? "12" : "" };
  });
}

function snapshotAnswers(): string {
  return JSON.stringify(answers);
}

function markBaseline() {
  baseline.value = snapshotAnswers();
}

function stopAutosaveTimer() {
  if (!autosaveTimer) return;
  clearTimeout(autosaveTimer);
  autosaveTimer = null;
}

function loadSheet() {
  fillAnswers(hydrateWizardAnswers(props.bizGubun, props.sugaList, props.sheetRows || []));
  stepIndex.value = 0;
  viewSource.value = "sheet";
  blanked.value = false;
  savedStep.value = 0;
  markBaseline();
}

function loadDraft(step: number, next: WizardAnswers) {
  fillAnswers(next);
  const last = Math.max(0, steps.value.length - 1);
  stepIndex.value = Math.min(Math.max(0, step), last);
  viewSource.value = "draft";
  blanked.value = false;
  savedStep.value = stepIndex.value;
  markBaseline();
}

function openFromStorage() {
  autosaveOn.value = false;
  stopAutosaveTimer();
  askKind.value = "";
  excludedAuto.value = {};
  detailOpen.value = {};
  blanked.value = false;
  const draft = readWizardDraft(props.draftKey);
  storedDraftAt.value = draft?.savedAt || "";
  if (draft) loadDraft(draft.stepIndex, draft.answers);
  else loadSheet();
  autosaveOn.value = true;
}

function saveDraft(closeAfter = false) {
  stopAutosaveTimer();
  if (!props.draftKey) {
    if (closeAfter) emit("update:modelValue", false);
    return;
  }
  const savedAt = new Date().toISOString();
  writeWizardDraft(props.draftKey, {
    savedAt,
    stepIndex: stepIndex.value,
    answers: JSON.parse(JSON.stringify(answers)) as WizardAnswers,
  });
  storedDraftAt.value = savedAt;
  viewSource.value = "draft";
  blanked.value = false;
  savedStep.value = stepIndex.value;
  markBaseline();
  if (closeAfter) emit("update:modelValue", false);
}

function scheduleAutosave() {
  if (!autosaveOn.value || !props.modelValue) return;
  if (!dirty.value && stepIndex.value === savedStep.value) return;
  stopAutosaveTimer();
  autosaveTimer = setTimeout(() => {
    autosaveTimer = null;
    if (!autosaveOn.value || !props.modelValue) return;
    if (!dirty.value && stepIndex.value === savedStep.value) return;
    saveDraft();
  }, 500);
}

function applyReset() {
  autosaveOn.value = false;
  stopAutosaveTimer();
  clearWizardDraft(props.draftKey);
  storedDraftAt.value = "";
  fillAnswers(createWizardAnswers(props.bizGubun, props.sugaList));
  stepIndex.value = 0;
  viewSource.value = "sheet";
  blanked.value = true;
  savedStep.value = 0;
  markBaseline();
  autosaveOn.value = true;
}

function discardClose() {
  askKind.value = "";
  emit("update:modelValue", false);
}

function requestClose() {
  if (dirty.value || stepIndex.value !== savedStep.value) saveDraft();
  emit("update:modelValue", false);
}

function requestSheet() {
  if (viewSource.value === "sheet" && !dirty.value && !blanked.value) return;
  if (dirty.value) askKind.value = "sheet";
  else loadSheet();
}

function requestDraft() {
  if (!storedDraftAt.value) return;
  if (viewSource.value === "draft" && !dirty.value) return;
  if (dirty.value) askKind.value = "draft";
  else {
    const draft = readWizardDraft(props.draftKey);
    if (draft) loadDraft(draft.stepIndex, draft.answers);
  }
}

function confirmAsk() {
  const kind = askKind.value;
  askKind.value = "";
  if (kind === "apply") {
    if (dirty.value || viewSource.value === "draft") saveDraft();
    emit("apply", built.value.lines);
    return;
  }
  if (kind === "close") {
    saveDraft(true);
    return;
  }
  if (kind === "sheet") {
    loadSheet();
    return;
  }
  if (kind === "draft") {
    const draft = readWizardDraft(props.draftKey);
    if (draft) loadDraft(draft.stepIndex, draft.answers);
    return;
  }
  if (kind === "reset") applyReset();
}

const dirty = computed(() => baseline.value !== "" && snapshotAnswers() !== baseline.value);

const sourceTime = computed(() => {
  if (!storedDraftAt.value) return "";
  const date = new Date(storedDraftAt.value);
  if (Number.isNaN(date.getTime())) return "";
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  return `${date.getMonth() + 1}월 ${date.getDate()}일 ${hour}:${minute}`;
});

const footState = computed(() => {
  if (dirty.value || stepIndex.value !== savedStep.value) return "임시저장 중";
  if (blanked.value) return "초기화됨";
  if (viewSource.value === "draft" && sourceTime.value) return `자동 임시저장됨 ${sourceTime.value}`;
  return "";
});

const showSheetLink = computed(() => viewSource.value === "draft" || dirty.value || blanked.value);
const showDraftLink = computed(() => Boolean(storedDraftAt.value) && !(viewSource.value === "draft" && !dirty.value));

const askTitle = computed(() => {
  if (askKind.value === "close") return "임시저장 후 닫기";
  if (askKind.value === "sheet") return "표로 되돌리기";
  if (askKind.value === "draft") return "임시저장으로 바꾸기";
  if (askKind.value === "reset") return "모두 지우기";
  return "표에 적용";
});

const askLead = computed(() => {
  if (askKind.value === "close") return "임시저장하지 않은 수정이 있습니다. 저장한 뒤 닫으면 다음에 이어서 볼 수 있습니다.";
  if (askKind.value === "sheet") return "마법사에서 고친 내용은 버리고, 예산 표에 적힌 값으로 다시 엽니다. 임시저장은 그대로 둡니다.";
  if (askKind.value === "draft") return "화면의 수정을 버리고 마지막 임시저장본을 다시 엽니다.";
  if (askKind.value === "reset") return "마법사에 적은 내용과 임시저장을 지우고 빈 화면으로 돌아갑니다. 예산 표는 바꾸지 않습니다.";
  if (!built.value.lines.length) return "적은 내용이 없습니다. 예산 표의 금액을 비웁니다. 서버에는 아직 저장되지 않습니다. 남기려면 예산 화면에서 저장을 누르세요.";
  if (viewSource.value === "draft") return "임시저장해 둔 내용으로 화면의 예산 표를 바꿉니다. 서버에는 아직 저장되지 않습니다. 남기려면 예산 화면에서 저장을 누르세요.";
  return "지금 적은 내용으로 화면의 예산 표를 바꿉니다. 서버에는 아직 저장되지 않습니다. 남기려면 예산 화면에서 저장을 누르세요.";
});

const askYes = computed(() => {
  if (askKind.value === "close") return "임시저장 후 닫기";
  if (askKind.value === "sheet") return "되돌리기";
  if (askKind.value === "draft") return "불러오기";
  if (askKind.value === "reset") return "지우기";
  return "표에 적용";
});

watch(stepIndex, () => {
  moneyQuery.value = "";
});

watch(
  () => (props.modelValue ? `${stepIndex.value}\n${snapshotAnswers()}` : ""),
  () => {
    scheduleAutosave();
  }
);

watch(
  () => props.modelValue,
  (open) => {
    if (!open) {
      autosaveOn.value = false;
      stopAutosaveTimer();
      askKind.value = "";
      return;
    }
    openFromStorage();
  }
);

onBeforeUnmount(() => {
  stopAutosaveTimer();
});

watch(
  () => (props.sugaList || []).map((row) => row.suga_rank).join("|"),
  () => {
    const list = props.sugaList || [];
    if (!list.length) return;
    const wasDirty = dirty.value;
    const freshGrades = createGradeAnswers(props.bizGubun, list);
    if (!answers.dayHours) answers.dayHours = preferredDayHours(list);
    if (!answers.grades.length) {
      answers.grades.push(...freshGrades);
      return;
    }
    freshGrades.forEach((grade, index) => {
      const current = answers.grades[index];
      if (!current) return;
      if (!current.rank) current.rank = grade.rank;
      if (!current.times) current.times = grade.times;
      if (!current.hours && grade.hours) current.hours = grade.hours;
    });
    if (!wasDirty) markBaseline();
  }
);

const built = computed(() => buildWizardLines(props.bizGubun, answers, props.sugaList, props.tax, excludedAutoKeys.value));
const labor = computed(() => laborStatus(built.value.lines, props.tax?.tr_labor_cost_rate));

function rateText(value: number) {
  const rounded = Math.round(value * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}

function reviewLines(trcode: "IN" | "OUT") {
  return built.value.lines.filter((line) => line.trcode === trcode);
}

function moneyBag(id: string) {
  if (!answers.money[id]) answers.money[id] = { a: "", b: "" };
  return answers.money[id];
}

function onDigits(target: { [key: string]: string }, key: string, event: Event) {
  const value = (event.target as HTMLInputElement).value.replace(/[^0-9]/g, "");
  target[key] = value;
}

function onWon(target: { [key: string]: string }, key: string, event: Event) {
  target[key] = formatWonInput((event.target as HTMLInputElement).value);
}

function onAnswerDigits(key: "treatmentCount", event: Event) {
  answers[key] = (event.target as HTMLInputElement).value.replace(/[^0-9]/g, "");
}

function onAnswerWon(key: "treatmentSubsidy" | "treatmentCopay", event: Event) {
  answers[key] = formatWonInput((event.target as HTMLInputElement).value);
}

function onMoney(id: string, key: "a" | "b", event: Event, won = true) {
  const bag = moneyBag(id);
  const raw = (event.target as HTMLInputElement).value;
  bag[key] = won && key === "a" ? formatWonInput(raw) : raw.replace(/[^0-9]/g, "");
  if (key === "b") bag[key] = raw.replace(/[^0-9]/g, "");
}

function addGrade() {
  answers.grades.push(extraGrade(props.bizGubun, props.sugaList, answers.dayHours, answers.grades.length));
}

function removeGrade(index: number) {
  if (answers.grades.length <= 1) return;
  answers.grades.splice(index, 1);
}

function onStaffRole(person: WizardAnswers["staff"][number]) {
  if (person.role !== "센터장") person.isCeo = false;
}

function addStaff(kind: "direct" | "indirect") {
  answers.staff.push({
    id: `s${Date.now()}`,
    role: kind === "indirect" ? "센터장" : "사회복지사",
    kind,
    isCeo: false,
    count: "",
    monthly: "",
  });
}

function removeStaff(index: number) {
  answers.staff.splice(index, 1);
}

function pairPreview(grade: WizardAnswers["grades"][number]) {
  const rank = resolvedGradeRank(family.value, grade, answers.dayHours);
  const suga = props.sugaList.find((row) => row.suga_rank === rank);
  const times = parseWon(grade.times);
  const count = parseWon(grade.count);
  const basicCount = parseWon(grade.basicCount);
  if (!suga || times <= 0 || (count <= 0 && basicCount <= 0)) return null;
  const normal = previewPair(suga, times, false);
  const basic = previewPair(suga, times, true);
  return {
    bonin: normal.bonin * count * 12,
    benefit: normal.benefit * count * 12,
    basicBenefit: basic.benefit * basicCount * 12,
    showNormal: count > 0,
    showBasic: familyUsesBasicSplit(family.value) && basicCount > 0,
  };
}

function staffPreview(person: WizardAnswers["staff"][number]) {
  const monthly = parseWon(person.monthly);
  const count = parseWon(person.count);
  if (monthly <= 0 || count <= 0) return null;
  const pay = monthly * count * 12;
  const ins = insuranceGridTotal(monthly, count, 12, person.isCeo, props.tax);
  const ret = retirementGridTotal(monthly, count, 12, person.isCeo);
  return { pay, ins, ret, annual: pay + ins + ret };
}



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "920",
    scrollable: "",
    persistent: "",
    class: "budget-wizard-dialog",
    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (showSheetLink.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "budget-wizard__tool",
                  onClick: requestSheet
                }, "표로 되돌리기"))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "budget-wizard__clear",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (askKind.value = 'reset'))
            }, "모두 지우기"),
            _createElementVNode("button", {
              type: "button",
              class: "budget-wizard__save",
              disabled: viewSource.value === 'draft' && !dirty.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (saveDraft()))
            }, "임시저장", 8, _hoisted_4),
            _createElementVNode("button", {
              type: "button",
              class: "dialog-close-x",
              title: "닫기",
              onClick: requestClose
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(__props.year) + " " + _toDisplayString(__props.budgetLabel), 1),
            _createElementVNode("span", null, _toDisplayString(__props.bizGubun || "사업"), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", _hoisted_7, _toDisplayString(step.value.title), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(stepIndex.value + 1) + "/" + _toDisplayString(steps.value.length), 1)
          ])
        ]),
        _createElementVNode("nav", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["budget-wizard__nav-btn", { 'is-on': index === stepIndex.value, 'is-done': index < stepIndex.value }]),
                onClick: ($event: any) => (goTo(index))
              }, [
                _createElementVNode("span", _hoisted_11, [
                  (index < stepIndex.value)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        size: "11"
                      }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("mdi-check", -1)
                        ]))]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(index + 1), 1)
                      ], 64))
                ]),
                _createElementVNode("span", _hoisted_12, _toDisplayString(item.nav), 1)
              ], 10, _hoisted_10),
              (index < steps.value.length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "budget-wizard__body",
          onKeydown: _withKeys(focusNextField, ["enter"])
        }, [
          (step.value.id === 'people')
            ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                (!__props.sugaList.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, "수가 없음"))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["wizard-grid", peopleGridClass.value])
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          _cache[18] || (_cache[18] = _createElementVNode("span", null, "등급", -1)),
                          (family.value === 'care')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "시간대"))
                            : (family.value === 'bath')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "차량 사용"))
                              : (family.value === 'day')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "시간대"))
                                : _createCommentVNode("", true),
                          (usesBasic.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "hc" }, "일반", -1)),
                                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "hc" }, "기초수급", -1))
                              ], 64))
                            : (_openBlock(), _createElementBlock("span", _hoisted_20, "인원")),
                          _cache[19] || (_cache[19] = _createElementVNode("span", { class: "hc" }, "월 횟수", -1)),
                          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "hr" }, "연간", -1)),
                          _cache[21] || (_cache[21] = _createElementVNode("span", null, null, -1))
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.grades, (grade, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: grade.id,
                            class: "wizard-grid__row"
                          }, [
                            (family.value === 'day' || family.value === 'facility')
                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 0,
                                  "onUpdate:modelValue": ($event: any) => ((grade.label) = $event),
                                  class: "budget-wizard__select"
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gradeLabelOptions)(__props.bizGubun), (name) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: name,
                                      value: name
                                    }, _toDisplayString(name), 9, _hoisted_22))
                                  }), 128))
                                ], 8, _hoisted_21)), [
                                  [_vModelSelect, grade.label]
                                ])
                              : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(grade.label), 1)),
                            (family.value === 'care' || family.value === 'bath')
                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 2,
                                  "onUpdate:modelValue": ($event: any) => ((grade.rank) = $event),
                                  class: "budget-wizard__select"
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sugaList, (suga) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: suga.suga_rank,
                                      value: suga.suga_rank
                                    }, _toDisplayString(suga.suga_rank), 9, _hoisted_25))
                                  }), 128))
                                ], 8, _hoisted_24)), [
                                  [_vModelSelect, grade.rank]
                                ])
                              : (family.value === 'day')
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 3,
                                    "onUpdate:modelValue": ($event: any) => ((grade.hours) = $event),
                                    class: "budget-wizard__select"
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hourOptions.value, (hour) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: hour,
                                        value: hour
                                      }, _toDisplayString(hour), 9, _hoisted_27))
                                    }), 128))
                                  ], 8, _hoisted_26)), [
                                    [_vModelSelect, grade.hours]
                                  ])
                                : _createCommentVNode("", true),
                            _createElementVNode("input", {
                              class: "budget-wizard__input budget-wizard__input--c",
                              inputmode: "numeric",
                              value: grade.count,
                              placeholder: "0",
                              onInput: ($event: any) => (onDigits(grade, 'count', $event))
                            }, null, 40, _hoisted_28),
                            (usesBasic.value)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 4,
                                  class: "budget-wizard__input budget-wizard__input--c",
                                  inputmode: "numeric",
                                  value: grade.basicCount,
                                  placeholder: "0",
                                  onInput: ($event: any) => (onDigits(grade, 'basicCount', $event))
                                }, null, 40, _hoisted_29))
                              : _createCommentVNode("", true),
                            _createElementVNode("input", {
                              class: "budget-wizard__input budget-wizard__input--c",
                              inputmode: "numeric",
                              value: grade.times,
                              placeholder: "0",
                              onInput: ($event: any) => (onDigits(grade, 'times', $event))
                            }, null, 40, _hoisted_30),
                            _createElementVNode("div", _hoisted_31, [
                              (pairPreview(grade))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (pairPreview(grade)!.showNormal)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                          _cache[22] || (_cache[22] = _createElementVNode("em", null, "본인부담", -1)),
                                          _createTextVNode(_toDisplayString(_unref(formatWon)(pairPreview(grade)!.bonin)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (pairPreview(grade)!.showNormal)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                          _cache[23] || (_cache[23] = _createElementVNode("em", null, "장기요양급여", -1)),
                                          _createTextVNode(_toDisplayString(_unref(formatWon)(pairPreview(grade)!.benefit)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (pairPreview(grade)!.showBasic)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                          _cache[24] || (_cache[24] = _createElementVNode("em", null, "기초수급", -1)),
                                          _createTextVNode(_toDisplayString(_unref(formatWon)(pairPreview(grade)!.basicBenefit)), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            (answers.grades.length > 1)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 5,
                                  type: "button",
                                  class: "wizard-grid__del",
                                  title: "행 삭제",
                                  onClick: ($event: any) => (removeGrade(index))
                                }, [
                                  _createVNode(_component_v_icon, { size: "15" }, {
                                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                      _createTextVNode("mdi-close", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ], 8, _hoisted_35))
                              : (_openBlock(), _createElementBlock("span", _hoisted_36))
                          ]))
                        }), 128))
                      ], 2),
                      _createElementVNode("button", {
                        type: "button",
                        class: "budget-wizard__ghost budget-wizard__ghost--block",
                        onClick: addGrade
                      }, [
                        _createVNode(_component_v_icon, { size: "15" }, {
                          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                            _createTextVNode("mdi-plus", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[27] || (_cache[27] = _createTextVNode(" 추가 ", -1))
                      ])
                    ], 64))
              ]))
            : (step.value.id === 'staff')
              ? (_openBlock(), _createElementBlock("section", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "wizard-grid__head" }, [
                      _createElementVNode("span", null, "직종"),
                      _createElementVNode("span", { class: "hc" }, "인원"),
                      _createElementVNode("span", { class: "hr" }, "월급"),
                      _createElementVNode("span", { class: "hc" }, "대표"),
                      _createElementVNode("span", { class: "hr" }, "연간"),
                      _createElementVNode("span")
                    ], -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.staff, (person, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: person.id,
                        class: "wizard-grid__row"
                      }, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((person.role) = $event),
                          class: "budget-wizard__select",
                          onChange: ($event: any) => (onStaffRole(person))
                        }, [
                          (person.role && !_unref(salaryRoleOptions)(person.kind, __props.bizGubun).includes(person.role))
                            ? (_openBlock(), _createElementBlock("option", {
                                key: 0,
                                value: person.role
                              }, _toDisplayString(person.role), 9, _hoisted_40))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(salaryRoleOptions)(person.kind, __props.bizGubun), (role) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: role,
                              value: role
                            }, _toDisplayString(role), 9, _hoisted_41))
                          }), 128))
                        ], 40, _hoisted_39), [
                          [_vModelSelect, person.role]
                        ]),
                        _createElementVNode("input", {
                          class: "budget-wizard__input budget-wizard__input--c",
                          inputmode: "numeric",
                          value: person.count,
                          placeholder: "0",
                          onInput: ($event: any) => (onDigits(person, 'count', $event))
                        }, null, 40, _hoisted_42),
                        _createElementVNode("input", {
                          class: "budget-wizard__input budget-wizard__input--r",
                          inputmode: "numeric",
                          value: person.monthly,
                          placeholder: "0",
                          onInput: ($event: any) => (onWon(person, 'monthly', $event))
                        }, null, 40, _hoisted_43),
                        (person.role === '센터장')
                          ? (_openBlock(), _createElementBlock("label", _hoisted_44, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((person.isCeo) = $event),
                                type: "checkbox"
                              }, null, 8, _hoisted_45), [
                                [_vModelCheckbox, person.isCeo]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_46)),
                        _createElementVNode("div", _hoisted_47, [
                          (staffPreview(person))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_unref(formatWon)(staffPreview(person)!.annual)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "wizard-grid__del",
                          title: "행 삭제",
                          onClick: ($event: any) => (removeStaff(index))
                        }, [
                          _createVNode(_component_v_icon, { size: "15" }, {
                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                              _createTextVNode("mdi-close", -1)
                            ]))]),
                            _: 1
                          })
                        ], 8, _hoisted_49)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "budget-wizard__ghost",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (addStaff('direct')))
                    }, [
                      _createVNode(_component_v_icon, { size: "15" }, {
                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                          _createTextVNode("mdi-plus", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[31] || (_cache[31] = _createTextVNode(" 현장 추가 ", -1))
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "budget-wizard__ghost",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (addStaff('indirect')))
                    }, [
                      _createVNode(_component_v_icon, { size: "15" }, {
                        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                          _createTextVNode("mdi-plus", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[33] || (_cache[33] = _createTextVNode(" 센터장 추가 ", -1))
                    ])
                  ]),
                  (_unref(familyUsesTreatment)(family.value))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _cache[37] || (_cache[37] = _createElementVNode("h3", { class: "wizard-mini__title" }, "처우개선비", -1)),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("label", _hoisted_53, [
                            _cache[34] || (_cache[34] = _createElementVNode("span", null, "인원", -1)),
                            _createElementVNode("input", {
                              class: "budget-wizard__input budget-wizard__input--c",
                              inputmode: "numeric",
                              value: answers.treatmentCount,
                              placeholder: "0",
                              onInput: _cache[4] || (_cache[4] = ($event: any) => (onAnswerDigits('treatmentCount', $event)))
                            }, null, 40, _hoisted_54)
                          ]),
                          _createElementVNode("label", _hoisted_55, [
                            _cache[35] || (_cache[35] = _createElementVNode("span", null, "기타보조금 (한 달)", -1)),
                            _createElementVNode("input", {
                              class: "budget-wizard__input budget-wizard__input--r",
                              inputmode: "numeric",
                              value: answers.treatmentSubsidy,
                              placeholder: "0",
                              onInput: _cache[5] || (_cache[5] = ($event: any) => (onAnswerWon('treatmentSubsidy', $event)))
                            }, null, 40, _hoisted_56)
                          ]),
                          _createElementVNode("label", _hoisted_57, [
                            _cache[36] || (_cache[36] = _createElementVNode("span", null, "본인부담 (한 달)", -1)),
                            _createElementVNode("input", {
                              class: "budget-wizard__input budget-wizard__input--r",
                              inputmode: "numeric",
                              value: answers.treatmentCopay,
                              placeholder: "0",
                              onInput: _cache[6] || (_cache[6] = ($event: any) => (onAnswerWon('treatmentCopay', $event)))
                            }, null, 40, _hoisted_58)
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            (treatmentAnnual() > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_unref(formatWon)(treatmentAnnual())), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (step.value.id === 'income' || step.value.id === 'spend')
                ? (_openBlock(), _createElementBlock("section", _hoisted_61, [
                    _createElementVNode("label", _hoisted_62, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((moneyQuery).value = $event)),
                        class: "budget-wizard__input wizard-find__input",
                        placeholder: "항목 이름 찾기"
                      }, null, 512), [
                        [_vModelText, moneyQuery.value]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMoneyGroups.value, (gwan) => {
                      return (_openBlock(), _createElementBlock("section", {
                        key: gwan.gwan,
                        class: "wizard-gwan"
                      }, [
                        _createElementVNode("h3", _hoisted_63, _toDisplayString(gwan.gwan), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gwan.hangs, (hang) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: gwan.gwan + '-' + hang.hang,
                            class: _normalizeClass(["wizard-hang", { 'is-plain': !hang.showHang }])
                          }, [
                            (hang.showHang)
                              ? (_openBlock(), _createElementBlock("h4", _hoisted_64, _toDisplayString(hang.hang), 1))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hang.groups, (group) => {
                              return (_openBlock(), _createElementBlock("section", {
                                key: gwan.gwan + '-' + hang.hang + '-' + group.title,
                                class: "wizard-money"
                              }, [
                                (group.fields.length > 1)
                                  ? (_openBlock(), _createElementBlock("h5", _hoisted_65, _toDisplayString(group.title), 1))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.fields, (field) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: field.id,
                                    class: "wizard-money__row"
                                  }, [
                                    _createElementVNode("div", _hoisted_66, [
                                      _createElementVNode("strong", null, _toDisplayString(field.label), 1)
                                    ]),
                                    _createElementVNode("span", _hoisted_67, _toDisplayString(moneyInputCopy(field.mode).a), 1),
                                    _createElementVNode("input", {
                                      class: "budget-wizard__input budget-wizard__input--r",
                                      inputmode: "numeric",
                                      value: moneyBag(field.id).a,
                                      placeholder: "0",
                                      onInput: ($event: any) => (onMoney(field.id, 'a', $event))
                                    }, null, 40, _hoisted_68),
                                    _createElementVNode("span", _hoisted_69, _toDisplayString(moneyInputCopy(field.mode).b), 1),
                                    (moneyInputCopy(field.mode).b)
                                      ? (_openBlock(), _createElementBlock("input", {
                                          key: 0,
                                          class: "budget-wizard__input budget-wizard__input--c",
                                          inputmode: "numeric",
                                          value: moneyBag(field.id).b,
                                          placeholder: field.mode === 'span' ? '12' : '0',
                                          onInput: ($event: any) => (onMoney(field.id, 'b', $event))
                                        }, null, 40, _hoisted_70))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_71)),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["wizard-money__year", { 'is-on': annualFieldAmount(field) > 0 }])
                                    }, _toDisplayString(annualFieldAmount(field) > 0 ? "1년 " + _unref(formatWon)(annualFieldAmount(field)) + "원" : ""), 3)
                                  ]))
                                }), 128))
                              ]))
                            }), 128))
                          ], 2))
                        }), 128))
                      ]))
                    }), 128)),
                    (!visibleMoneyGroups.value.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_72, "찾는 항목이 없습니다."))
                      : _createCommentVNode("", true)
                  ]))
                : (step.value.id === 'review')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("div", _hoisted_75, [
                          _cache[38] || (_cache[38] = _createElementVNode("span", null, "세입", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_unref(formatWon)(built.value.income)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _cache[39] || (_cache[39] = _createElementVNode("span", null, "세출", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_unref(formatWon)(built.value.expense)), 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["wizard-total", built.value.income - built.value.expense < 0 ? 'wizard-total--neg' : 'wizard-total--diff'])
                        }, [
                          _cache[40] || (_cache[40] = _createElementVNode("span", null, "차액", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_unref(formatWon)(built.value.income - built.value.expense)), 1)
                        ], 2)
                      ]),
                      (labor.value.base > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["wizard-banner", labor.value.ok ? 'is-ok' : 'is-short'])
                          }, [
                            _createElementVNode("div", _hoisted_77, [
                              _cache[41] || (_cache[41] = _createElementVNode("span", { class: "wizard-banner__label" }, "인건비 비율", -1)),
                              _createElementVNode("strong", _hoisted_78, _toDisplayString(rateText(labor.value.rate)) + "%", 1)
                            ]),
                            _createElementVNode("div", _hoisted_79, [
                              _createElementVNode("span", null, "기준 " + _toDisplayString(rateText(labor.value.required)) + "%", 1),
                              _createElementVNode("strong", null, _toDisplayString(labor.value.ok ? "충족" : _unref(formatWon)(labor.value.shortMoney) + "원 미달"), 1)
                            ])
                          ], 2))
                        : _createCommentVNode("", true),
                      (!built.value.lines.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_80, "적은 내용이 없습니다. 표에 적용하면 예산 표의 금액이 비워집니다."))
                        : (_openBlock(), _createElementBlock("div", _hoisted_81, [
                            _createElementVNode("div", _hoisted_82, [
                              _cache[42] || (_cache[42] = _createElementVNode("h3", { class: "wizard-review__title wizard-review__title--in" }, "세입", -1)),
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reviewLines('IN'), (line, index) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: 'in' + index
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(line.reviewLabel), 1),
                                    _createElementVNode("strong", null, _toDisplayString(_unref(formatWon)(_unref(lineAmount)(line))), 1)
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_83, [
                              _cache[43] || (_cache[43] = _createElementVNode("h3", { class: "wizard-review__title wizard-review__title--out" }, "세출", -1)),
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reviewLines('OUT'), (line, index) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: 'out' + index
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(line.reviewLabel), 1),
                                    _createElementVNode("strong", null, _toDisplayString(_unref(formatWon)(_unref(lineAmount)(line))), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                    ]))
                  : _createCommentVNode("", true)
        ], 32),
        _createElementVNode("footer", _hoisted_84, [
          (built.value.income || built.value.expense)
            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                _createElementVNode("span", _hoisted_86, [
                  _cache[44] || (_cache[44] = _createElementVNode("em", null, "세입", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_unref(formatWon)(built.value.income)) + "원", 1)
                ]),
                _createElementVNode("span", _hoisted_87, [
                  _cache[45] || (_cache[45] = _createElementVNode("em", null, "세출", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_unref(formatWon)(built.value.expense)) + "원", 1)
                ]),
                (labor.value.base > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_88, [
                      _cache[46] || (_cache[46] = _createElementVNode("em", null, "인건비지출비율", -1)),
                      _createElementVNode("strong", {
                        class: _normalizeClass(labor.value.ok ? 'is-ok' : 'is-short')
                      }, _toDisplayString(rateText(labor.value.rate)) + "%", 3),
                      _createElementVNode("small", null, "기준 " + _toDisplayString(rateText(labor.value.required)) + "%", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", { class: "budget-wizard__foot-leave" }, [
              _createElementVNode("button", {
                type: "button",
                class: "budget-wizard__btn budget-wizard__btn--quiet",
                onClick: requestClose
              }, "닫기")
            ]),
            _createElementVNode("div", _hoisted_90, [
              (footState.value || showDraftLink.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_91, [
                    (footState.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(footState.value), 1))
                      : _createCommentVNode("", true),
                    (showDraftLink.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "wizard-foot-link",
                          onClick: requestDraft
                        }, "임시저장 불러오기"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("button", {
                type: "button",
                class: "budget-wizard__btn",
                disabled: stepIndex.value === 0,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (stepIndex.value -= 1))
              }, [
                _createVNode(_component_v_icon, { size: "15" }, {
                  default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                    _createTextVNode("mdi-chevron-left", -1)
                  ]))]),
                  _: 1
                }),
                _cache[48] || (_cache[48] = _createTextVNode(" 이전 ", -1))
              ], 8, _hoisted_94),
              (step.value.id !== 'review')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "budget-wizard__btn budget-wizard__btn--next",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (stepIndex.value += 1))
                  }, [
                    _cache[50] || (_cache[50] = _createTextVNode(" 다음 ", -1)),
                    _createVNode(_component_v_icon, { size: "15" }, {
                      default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "budget-wizard__btn budget-wizard__btn--next",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (askKind.value = 'apply'))
                  }, [
                    _createVNode(_component_v_icon, { size: "15" }, {
                      default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[52] || (_cache[52] = _createTextVNode(" 표에 적용 ", -1))
                  ]))
            ])
          ])
        ]),
        (askKind.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "wizard-ask",
              onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (askKind.value = ''), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("h3", _hoisted_96, _toDisplayString(askTitle.value), 1),
                _createElementVNode("p", _hoisted_97, _toDisplayString(askLead.value), 1),
                (askKind.value === 'apply' && autoGroups.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                      _createElementVNode("p", _hoisted_99, [
                        _cache[53] || (_cache[53] = _createTextVNode(" 같이 넣는 돈 ", -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(formatWon)(autoKeptTotal.value)) + "원", 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(autoGroups.value, (group) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: group.id,
                          class: "wizard-ask__group"
                        }, [
                          _createElementVNode("div", _hoisted_100, [
                            _createElementVNode("label", {
                              class: _normalizeClass(["wizard-ask__auto-item", { 'is-off': groupKept(group) === 0 }])
                            }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: groupKeptCount(group) === group.items.length,
                                ref_for: true,
                                ref: (el) => paintGroupBox(el, group),
                                onChange: ($event: any) => (toggleGroup(group))
                              }, null, 40, _hoisted_101),
                              _createElementVNode("span", _hoisted_102, _toDisplayString(group.title), 1),
                              _createElementVNode("strong", null, _toDisplayString(_unref(formatWon)(groupKept(group) || groupTotal(group))) + "원", 1)
                            ], 2),
                            (group.items.length > 1)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "wizard-ask__detail",
                                  onClick: ($event: any) => (toggleDetail(group.id))
                                }, _toDisplayString(detailOpen.value[group.id] ? "접기" : "세부사항"), 9, _hoisted_103))
                              : _createCommentVNode("", true)
                          ]),
                          (group.items.length > 1 && detailOpen.value[group.id])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                                  return (_openBlock(), _createElementBlock("label", {
                                    key: item.key,
                                    class: _normalizeClass(["wizard-ask__auto-item is-child", { 'is-off': isAutoOff(item) }])
                                  }, [
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      checked: !isAutoOff(item),
                                      onChange: ($event: any) => (toggleAuto(item))
                                    }, null, 40, _hoisted_105),
                                    _createElementVNode("span", _hoisted_106, _toDisplayString(item.label), 1),
                                    _createElementVNode("strong", null, _toDisplayString(_unref(formatWon)(item.amount)) + "원", 1)
                                  ], 2))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      _cache[54] || (_cache[54] = _createElementVNode("p", { class: "wizard-ask__auto-hint" }, "체크를 빼면 그 돈은 표에 적용하지 않습니다. 생계비를 이미 적었다면 그 줄은 빠져 있습니다.", -1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_107, [
                  (askKind.value === 'close')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "budget-wizard__btn",
                        onClick: discardClose
                      }, "저장 없이 닫기"))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "budget-wizard__btn",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (askKind.value = ''))
                  }, _toDisplayString(askKind.value === "close" ? "계속 작성" : "아니요"), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "budget-wizard__btn budget-wizard__btn--next",
                    onClick: confirmAsk
                  }, _toDisplayString(askYes.value), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})